import { MouseEventHandler } from 'react';

import { makeStyles } from '@material-ui/core';

import { RED } from 'constants/colors';

import CloseIcon from '@mui/icons-material/Close';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignSelf: 'baseline',
    position: 'absolute',
    alignItems: 'center',
    left: 0,
    width: '40px',
    height: '40px',
    transform: 'translate(-100%, 0)',
    borderRadius: '50% !important',
    color: RED,
    cursor: 'pointer'
  }
}));

const RemoveButton: React.FC<{
  onClick: MouseEventHandler<HTMLDivElement>;
}> = ({ onClick }) => {
  const classes = useStyles();
  return (
    <div className={classes.root} onClick={onClick}>
      <CloseIcon />
    </div>
  );
};

export default RemoveButton;
